
// This file is meant to be a representation of an array of JSON objects that contains 
// web develop projects/works to be displayed on the portfolio section
export const works = [
    {
        'id': 'beautyndesigns',
        'name': 'Accesorios y Belleza Nardis',
        'url': 'beautyndesigns.com',
        'technologies': 'JS, React, Node',
        'categories': 'Desarrollo web',
        'description': 'Sitio web para ofrecer servicios de belleza como tratamientos para el cabello o confeccion de bisuteria.'
    }/* ,

    {
        'id': 'facebook',
        'name': 'Facebook',
        'url': 'facebook.com',
        'technologies': 'React, Node, Mongo',
        'categories': 'Desarrollo web',
        'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus finibus ante magna, a convallis odio porta vel. Nunc velit nisi, faucibus sed porttitor vel, eleifend vel nulla. Nulla aliquet, elit at porta consequat, lacus sem suscipit ipsum, hendrerit iaculis massa lacus vitae lectus. Nam at faucibus est, sed dictum metus'
    },

    {
        'id': 'twitter',
        'name': 'Twitter',
        'url': 'twitter.com',
        'technologies': 'HTML, CSS',
        'categories': 'Maquetacion web',
        'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus finibus ante magna, a convallis odio porta vel. Nunc velit nisi, faucibus sed porttitor vel, eleifend vel nulla. Nulla aliquet, elit at porta consequat, lacus sem suscipit ipsum, hendrerit iaculis massa lacus vitae lectus. Nam at faucibus est, sed dictum metus'
    },

    {
        'id': 'linkedin',
        'name': 'Linkedin',
        'url': 'linkedin.com',
        'technologies': 'HTML, CSS, JS, PHP, Laravel',
        'categories': 'Desarrollo web',
        'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus finibus ante magna, a convallis odio porta vel. Nunc velit nisi, faucibus sed porttitor vel, eleifend vel nulla. Nulla aliquet, elit at porta consequat, lacus sem suscipit ipsum, hendrerit iaculis massa lacus vitae lectus. Nam at faucibus est, sed dictum metus'
    },

    {
        'id': 'udemy',
        'name': 'Udemy',
        'url': 'udemy.com/user/victor-robles-2/',
        'technologies': 'MERN Stack',
        'categories': 'Desarrollo web',
        'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus finibus ante magna, a convallis odio porta vel. Nunc velit nisi, faucibus sed porttitor vel, eleifend vel nulla. Nulla aliquet, elit at porta consequat, lacus sem suscipit ipsum, hendrerit iaculis massa lacus vitae lectus. Nam at faucibus est, sed dictum metus'
    },

    {
        'id': 'youtube',
        'name': 'YouTube',
        'url': 'youtube.com',
        'technologies': 'JS, React, PHP, Symfony',
        'categories': 'Desarrollo web',
        'description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus finibus ante magna, a convallis odio porta vel. Nunc velit nisi, faucibus sed porttitor vel, eleifend vel nulla. Nulla aliquet, elit at porta consequat, lacus sem suscipit ipsum, hendrerit iaculis massa lacus vitae lectus. Nam at faucibus est, sed dictum metus'
    } */
];
